module.exports = __webpack_public_path__ + "img/Produktion DVS-50.51ea5fc9.webp";